























































import Vue, { PropType } from 'vue';
import NotificationText from '../common/NotificationText/NotificationText.vue';
import CheckBox from '../common/CheckBox/CheckBox.vue';

import { parsedObjectInfoI } from '@/interfaces/parsedObjectInfoI';

export default Vue.extend({
  props: {
    getResult: {
      type: Boolean,
    },
    parsedObject: {
      type: Array as PropType<parsedObjectInfoI[]>,
    },
  },
  components: {
    NotificationText,
    CheckBox,
  },
  data(): {
    error: boolean;
    keySelected: boolean[];
  } {
    return {
      error: false,
      keySelected: [],
    };
  },
  created() {
    /*const initialObject = {
      tmp: [
        [1, 2, 3],
        [4, 5, 6],
      ],
      tmp2: [
        { key: 'jihoon', value: 5, checkList: [7, 8, 9] },
        { key: 'soomin', value: 30 },
      ],
      tmp3: { value: [1, 2, 3] },
      meta: {
        code: 200,
        requestId: '71f19976-9607-4aa7-a1b9-2c9666f0e220',
      },
      data: {
        id: 10000,
        brandName: 'Palm Tree',
        gender: 'Women',
        crossLinks: [
          {
            key: 'More Skirts by Palm Tree',
            value: 'skirts?f=brand:Palm Tree::gender:women',
          },
          {
            key: 'More White Skirts',
            value: 'skirts?f=colour:White::gender:women',
          },
          {
            key: 'More Skirts',
            value: 'skirts?f=gender:women',
          },
        ],
        styleImages: {
          default: {
            imageURL:
              'http://assets.myntassets.com/v1/images/style/properties/df30bc92249a83ec84b5ba682bf5a0fa_images.jpg',
            resolutions: {
              '1080X1440Xmini':
                'http://assets.myntassets.com/h_1440,q_95,w_1080/v1/images/style/properties/df30bc92249a83ec84b5ba682bf5a0fa_images_mini.jpg',
              '48X64':
                'http://assets.myntassets.com/h_64,q_95,w_48/v1/images/style/properties/df30bc92249a83ec84b5ba682bf5a0fa_images.jpg',
              '1080X1440':
                'http://assets.myntassets.com/h_1440,q_95,w_1080/v1/images/style/properties/df30bc92249a83ec84b5ba682bf5a0fa_images.jpg',
              '150X200':
                'http://assets.myntassets.com/h_200,q_95,w_150/v1/images/style/properties/df30bc92249a83ec84b5ba682bf5a0fa_images.jpg',
              '360X480':
                'http://assets.myntassets.com/h_480,q_95,w_360/v1/images/style/properties/df30bc92249a83ec84b5ba682bf5a0fa_images.jpg',
              '180X240':
                'http://assets.myntassets.com/h_240,q_95,w_180/v1/images/style/properties/df30bc92249a83ec84b5ba682bf5a0fa_images.jpg',
              '360X480Xmini':
                'http://assets.myntassets.com/h_480,q_95,w_360/v1/images/style/properties/df30bc92249a83ec84b5ba682bf5a0fa_images_mini.jpg',
              '180X240Xmini':
                'http://assets.myntassets.com/h_240,q_95,w_180/v1/images/style/properties/df30bc92249a83ec84b5ba682bf5a0fa_images_mini.jpg',
              '150X200Xmini':
                'http://assets.myntassets.com/h_200,q_95,w_150/v1/images/style/properties/df30bc92249a83ec84b5ba682bf5a0fa_images_mini.jpg',
              '48X64Xmini':
                'http://assets.myntassets.com/h_64,q_95,w_48/v1/images/style/properties/df30bc92249a83ec84b5ba682bf5a0fa_images_mini.jpg',
              '125X161':
                'http://assets.myntassets.com/h_161,q_95,w_125/v1/images/style/properties/df30bc92249a83ec84b5ba682bf5a0fa_images.jpg',
              '125X161Xmini':
                'http://assets.myntassets.com/h_161,q_95,w_125/v1/images/style/properties/df30bc92249a83ec84b5ba682bf5a0fa_images_mini.jpg',
            },
            imageType: 'default',
          },
          size_representation:
            'http://myntra.myntassets.com/images/style/sizechartimages/af1b2e903cc39d98f6e1cd1e2ac7abdd.jpg',
          search: {
            imageURL:
              'http://assets.myntassets.com/v1/images/style/properties/df30bc92249a83ec84b5ba682bf5a0fa_images.jpg',
            resolutions: {
              '1080X1440Xmini':
                'http://assets.myntassets.com/h_1440,q_95,w_1080/v1/images/style/properties/df30bc92249a83ec84b5ba682bf5a0fa_images_mini.jpg',
              '48X64':
                'http://assets.myntassets.com/h_64,q_95,w_48/v1/images/style/properties/df30bc92249a83ec84b5ba682bf5a0fa_images.jpg',
              '1080X1440':
                'http://assets.myntassets.com/h_1440,q_95,w_1080/v1/images/style/properties/df30bc92249a83ec84b5ba682bf5a0fa_images.jpg',
              '150X200':
                'http://assets.myntassets.com/h_200,q_95,w_150/v1/images/style/properties/df30bc92249a83ec84b5ba682bf5a0fa_images.jpg',
              '360X480':
                'http://assets.myntassets.com/h_480,q_95,w_360/v1/images/style/properties/df30bc92249a83ec84b5ba682bf5a0fa_images.jpg',
              '180X240':
                'http://assets.myntassets.com/h_240,q_95,w_180/v1/images/style/properties/df30bc92249a83ec84b5ba682bf5a0fa_images.jpg',
              '360X480Xmini':
                'http://assets.myntassets.com/h_480,q_95,w_360/v1/images/style/properties/df30bc92249a83ec84b5ba682bf5a0fa_images_mini.jpg',
              '180X240Xmini':
                'http://assets.myntassets.com/h_240,q_95,w_180/v1/images/style/properties/df30bc92249a83ec84b5ba682bf5a0fa_images_mini.jpg',
              '150X200Xmini':
                'http://assets.myntassets.com/h_200,q_95,w_150/v1/images/style/properties/df30bc92249a83ec84b5ba682bf5a0fa_images_mini.jpg',
              '48X64Xmini':
                'http://assets.myntassets.com/h_64,q_95,w_48/v1/images/style/properties/df30bc92249a83ec84b5ba682bf5a0fa_images_mini.jpg',
              '125X161':
                'http://assets.myntassets.com/h_161,q_95,w_125/v1/images/style/properties/df30bc92249a83ec84b5ba682bf5a0fa_images.jpg',
              '125X161Xmini':
                'http://assets.myntassets.com/h_161,q_95,w_125/v1/images/style/properties/df30bc92249a83ec84b5ba682bf5a0fa_images_mini.jpg',
            },
            imageType: 'search',
          },
          back: {
            imageURL:
              'http://assets.myntassets.com/v1/images/style/properties/bfb5831f0c2de27b2e92a286a67dfe2d_images.jpg',
            resolutions: {
              '1080X1440Xmini':
                'http://assets.myntassets.com/h_1440,q_95,w_1080/v1/images/style/properties/bfb5831f0c2de27b2e92a286a67dfe2d_images_mini.jpg',
              '48X64':
                'http://assets.myntassets.com/h_64,q_95,w_48/v1/images/style/properties/bfb5831f0c2de27b2e92a286a67dfe2d_images.jpg',
              '1080X1440':
                'http://assets.myntassets.com/h_1440,q_95,w_1080/v1/images/style/properties/bfb5831f0c2de27b2e92a286a67dfe2d_images.jpg',
              '150X200':
                'http://assets.myntassets.com/h_200,q_95,w_150/v1/images/style/properties/bfb5831f0c2de27b2e92a286a67dfe2d_images.jpg',
              '360X480':
                'http://assets.myntassets.com/h_480,q_95,w_360/v1/images/style/properties/bfb5831f0c2de27b2e92a286a67dfe2d_images.jpg',
              '180X240':
                'http://assets.myntassets.com/h_240,q_95,w_180/v1/images/style/properties/bfb5831f0c2de27b2e92a286a67dfe2d_images.jpg',
              '360X480Xmini':
                'http://assets.myntassets.com/h_480,q_95,w_360/v1/images/style/properties/bfb5831f0c2de27b2e92a286a67dfe2d_images_mini.jpg',
              '180X240Xmini':
                'http://assets.myntassets.com/h_240,q_95,w_180/v1/images/style/properties/bfb5831f0c2de27b2e92a286a67dfe2d_images_mini.jpg',
              '150X200Xmini':
                'http://assets.myntassets.com/h_200,q_95,w_150/v1/images/style/properties/bfb5831f0c2de27b2e92a286a67dfe2d_images_mini.jpg',
              '48X64Xmini':
                'http://assets.myntassets.com/h_64,q_95,w_48/v1/images/style/properties/bfb5831f0c2de27b2e92a286a67dfe2d_images_mini.jpg',
              '125X161':
                'http://assets.myntassets.com/h_161,q_95,w_125/v1/images/style/properties/bfb5831f0c2de27b2e92a286a67dfe2d_images.jpg',
              '125X161Xmini':
                'http://assets.myntassets.com/h_161,q_95,w_125/v1/images/style/properties/bfb5831f0c2de27b2e92a286a67dfe2d_images_mini.jpg',
            },
            imageType: 'back',
          },
          front: {
            imageURL:
              'http://assets.myntassets.com/v1/images/style/properties/9337a8658583897488c5875e65031dac_images.jpg',
            resolutions: {
              '1080X1440Xmini':
                'http://assets.myntassets.com/h_1440,q_95,w_1080/v1/images/style/properties/9337a8658583897488c5875e65031dac_images_mini.jpg',
              '48X64':
                'http://assets.myntassets.com/h_64,q_95,w_48/v1/images/style/properties/9337a8658583897488c5875e65031dac_images.jpg',
              '1080X1440':
                'http://assets.myntassets.com/h_1440,q_95,w_1080/v1/images/style/properties/9337a8658583897488c5875e65031dac_images.jpg',
              '150X200':
                'http://assets.myntassets.com/h_200,q_95,w_150/v1/images/style/properties/9337a8658583897488c5875e65031dac_images.jpg',
              '360X480':
                'http://assets.myntassets.com/h_480,q_95,w_360/v1/images/style/properties/9337a8658583897488c5875e65031dac_images.jpg',
              '180X240':
                'http://assets.myntassets.com/h_240,q_95,w_180/v1/images/style/properties/9337a8658583897488c5875e65031dac_images.jpg',
              '360X480Xmini':
                'http://assets.myntassets.com/h_480,q_95,w_360/v1/images/style/properties/9337a8658583897488c5875e65031dac_images_mini.jpg',
              '180X240Xmini':
                'http://assets.myntassets.com/h_240,q_95,w_180/v1/images/style/properties/9337a8658583897488c5875e65031dac_images_mini.jpg',
              '150X200Xmini':
                'http://assets.myntassets.com/h_200,q_95,w_150/v1/images/style/properties/9337a8658583897488c5875e65031dac_images_mini.jpg',
              '48X64Xmini':
                'http://assets.myntassets.com/h_64,q_95,w_48/v1/images/style/properties/9337a8658583897488c5875e65031dac_images_mini.jpg',
              '125X161':
                'http://assets.myntassets.com/h_161,q_95,w_125/v1/images/style/properties/9337a8658583897488c5875e65031dac_images.jpg',
              '125X161Xmini':
                'http://assets.myntassets.com/h_161,q_95,w_125/v1/images/style/properties/9337a8658583897488c5875e65031dac_images_mini.jpg',
            },
            imageType: 'front',
          },
        },
      },
    };*/

    this.keySelected = this.parsedObject.map(() => {
      return false;
    });
  },
  methods: {
    normalizeToParsingRuleArray(
      currentIndex: number,
      currentDepth: number,
    ): any[] | null {
      const normalizedParsedObject: any[] | null = [];
      let isValid = false;

      for (
        var index = currentIndex;
        index < this.parsedObject.length;
        index++
      ) {
        const parsedInfo = this.parsedObject[index];
        if (this.keySelected[index]) {
          if (parsedInfo.depth < currentDepth) {
            break;
          } else if (parsedInfo.depth == currentDepth) {
            isValid = true;
            if (!parsedInfo.isItem) {
              normalizedParsedObject.push(parsedInfo.name);
            }
            const nextParsedInfo = this.normalizeToParsingRuleArray(
              index + 1,
              currentDepth + 1,
            );

            if (nextParsedInfo !== null) {
              normalizedParsedObject.push(nextParsedInfo);
            }
          }
        }
      }

      if (isValid) return normalizedParsedObject;
      return null;
    },
    onClickNextButton() {
      if (
        !this.keySelected.reduce((acc, x) => {
          if (x) {
            return true;
          }
          return acc;
        }, false)
      ) {
        this.error = true;
      }

      let payload: {
        ok: boolean;
        exampleData: parsedObjectInfoI[];
        parsing_rule: {
          properties: any;
        };
      } = {
        ok: !this.error,
        exampleData: [],
        parsing_rule: {
          properties: [''],
        },
      };

      const exampleData = this.parsedObject.filter((_, index: number) => {
        return this.keySelected[index];
      });
      payload.exampleData = exampleData;

      payload['parsing_rule'].properties = this.normalizeToParsingRuleArray(
        0,
        this.parsedObject[0].depth,
      );

      this.$emit('pushResult', payload);
    },
  },
  watch: {
    keySelected: function (keySelected: boolean[]) {
      let newKeySelected: boolean[] = keySelected;
      let checkStack: number[] = [];

      newKeySelected.forEach((isSelected: boolean, idx: number) => {
        while (
          checkStack.length > 0 &&
          checkStack.length + this.parsedObject[checkStack[0]].depth >
            this.parsedObject[idx].depth
        ) {
          checkStack.pop();
        }

        if (isSelected) {
          checkStack.forEach((newKeySelectedIdx: number) => {
            newKeySelected[newKeySelectedIdx] = true;
          });
        }

        checkStack.push(idx);
      });

      this.keySelected = newKeySelected;
    },
    getResult: function (getResult) {
      if (getResult === true) {
        this.onClickNextButton();
      }
    },
  },
});
